import React, { useCallback, useEffect, useMemo, useState } from "react";
import ReactFlow, { isNode, MiniMap } from "react-flow-renderer";
import { useNavigate } from "react-router-dom";
import CustomNode from "../../admin/process/CustomNode";
import "react-flow-renderer/dist/theme-default.css";
import { useSelector } from "react-redux";
import { selectReduxInstance } from "../../../redux/ReduxInstance";
import CustomEdge from "../../admin/process/ButtonEdges";

const BoardView = (props) => {
  const { nodes, edges, handleShowDetailView, handleShowOrgunitsList } = props;
  const navigate = useNavigate();
  const [reactflowInstance, setReactflowInstance] = useState(null);
  const ReduxInstance = useSelector(selectReduxInstance);

  useEffect(() => {
    if (reactflowInstance) {
      if (nodes.length) {
        let _nodes_y = nodes.sort((a, b) => {
          return a.position.y - b.position.y;
        });
        let _nodes_x = nodes.sort((a, b) => {
          return a.position.x - b.position.x;
        });

        // console.log("x", _nodes_x[0].position.x + 450);
        // console.log("y", _nodes_y[0].position.x + 450);
        
        reactflowInstance.setCenter(
          _nodes_x[0].position.x + 200, // Différence avec la taille du noeud
          _nodes_y[0].position.y + 300, // Marge supplémentaire pour coller au plafond
          {
            zoom: 0.65,
            duration: 500,
          }
        );
      }
    }
  }, [reactflowInstance, nodes]);

  const onElementClick = (event, element) => {
    if (event.target.matches(".no-interact")) {
      handleShowOrgunitsList(element.data.process);
    } else {
      if (element.data.process.view.length > 0) {
        navigate("/processes/" + element.data.process._id);
      } else {
        handleShowDetailView(element.data.process);
      }
    }
  };

  // Initialisation du Node Custom
  const nodeTypes = useMemo(() => ({ special: CustomNode }), []);
  const edgeTypes = useMemo(() => ({ buttonedge: CustomEdge }), []);

  return (
    <ReactFlow
      onInit={setReactflowInstance}
      nodeTypes={nodeTypes}
      edgeTypes={edgeTypes}
      nodes={nodes}
      edges={edges}
      nodesDraggable={false}
      elementsSelectable={false}
      nodesConnectable={false}
      onNodeClick={onElementClick}
    >
      <MiniMap
        nodeColor={(node) => {
          switch (node.data.template) {
            case 0:
              return "#505050";
            case 1:
              return ReduxInstance.couleur;
            case 2:
              return ReduxInstance.couleur;
            default:
              return "#eee";
          }
        }}
        nodeStrokeWidth={3}
      />
    </ReactFlow>
  );
};

export default BoardView;
